// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DocumentForm__wrapper__TSgEn","submitResult":"DocumentForm__submitResult__18SDE","actionWrapper":"DocumentForm__actionWrapper__LvprP","wrapper2faOptions":"DocumentForm__wrapper2faOptions__1SEMm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentForm/DocumentForm.css
// module id = 327
// module chunks = 0